import React from 'react';

const BlockItem = ({title, amount}) => {
    return (
        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: 8}}>
            <span style={{
                color: 'hsla(0,0%,100%,.5)',
                width: '100%',
                fontSize: '14px',
                fontFamily: 'PT-sans, sans-serif',
                paddingBottom: 4
            }}>{title}:</span>
            <span
                style={{
                    color: '#fff',
                    fontSize: 14,
                    fontFamily: 'PT-sans, sans-serif', 
                }}
            >
                {amount}
            </span>
        </div>
    )
}

export default BlockItem